import { withState } from 'recompose';

export default withState('subtab', 'updateSubtab', 'funding');
